import React from 'react';
import { Form, FieldsForm } from 'clad';

class BuildForm extends React.Component {
    constructor(props) {
        super(props);
        // const getThis = () => this;

        this.WrappedFieldsForm = Form.create({})(FieldsForm);
    }

    render() {
        const { fields, record } = this.props;
        const { WrappedFieldsForm } = this;

        return (
            <WrappedFieldsForm
                wrappedComponentRef={el => (this.formRef = el)}
                fields={fields}
                record={record}
            />
        );
    }
}

export default BuildForm;
